var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.items.length && _vm.can('vender.limpiar_venta'))?_c('b-button',{staticClass:"m-l-10 m-b-10",attrs:{"variant":"outline-danger"},on:{"click":_vm.call_limpiar_vender}},[_c('i',{staticClass:"icon-undo"}),_vm._v(" Limpiar ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }